export const Syllabus_mtech = [
    {
        "BRANCH" : "CHEMICAL ENGINEERING",
        "Filename": "CHE R23 SYLLABUS",
        "location": "NA"
    }, {
        "BRANCH" : "CIVIL ENGINEERING",
        "Filename": "CE R23 SYLLABUS",
        "location": "/academics/CE_M.Tech_R-23_SYLLABUS.pdf"
    }, {
        "BRANCH" : "ELECTRICAL & ELECTRONICS ENGINEERING",
        "Filename": "EEE R23 SYLLABUS",
        "location": "/academics/documents/mtechr23ee.pdf"
    }, {
        "BRANCH" : "ELECTRONICS AND COMMUNICATION ENGINEERING",
        "Filename": "ECE SP R23 SYLLABUS",
        "location": "/academics/documents/M.Tech_R23_ECE _SPSyllabus.pdf"
    }, 
    {
        "BRANCH" : "ELECTRONICS AND COMMUNICATION ENGINEERING",
        "Filename": "ECE CM R23 SYLLABUS",
        "location": "/academics/documents/M.Tech_R23_ECE_CMSyllabus.pdf"
    }, {
        "BRANCH" : "MECHANICAL ENGINEERING",
        "Filename": "ME (E) R23 SYLLABUS",
        "location": "/academics/documents/mtech_me_e_r23.pdf"
    },
    {
        "BRANCH" : "MECHANICAL ENGINEERING",
        "Filename": "ME (PE) R23 SYLLABUS",
        "location": "/academics/documents/mtech_me_pe_r23.pdf"
    }, {
        "BRANCH" : "COMPUTER SCIENCE AND ENGINEERING",
        "Filename": "CSE R23 SYLLABUS",
        "location" :"/academics/documents/m-tech syallbus2023.pdf"
    },
    // {
    //     "BRANCH" : "COMPUTER SCIENCE AND ENGINEERING",
    //     "Filename": "CSE R23 SYLLABUS",
    //     "location" :"/academics/SVUCE_MTech_CSE_R2018_Syllabus.pdf"
    // }
    
]